import React from 'react';

import App from 'components/app';

export const wrapPageElement = ({ element }) => <App>{element}</App>;
